const pacienteModule = {
  state: {
    paciente: null
  },

  mutations: {
    SET_PACIENTE: (state, paciente) => {
      state.paciente = paciente
    },
    CLEAR_PACIENTE: (state) => {
      state.paciente = null
    },
    UPDATE_PACIENTE: (state, dadosAtualizados) => {
      if (state.paciente) {
        state.paciente = { ...state.paciente, ...dadosAtualizados }
      }
    }
  },

  actions: {
    setPaciente({ commit }, paciente) {
      commit('SET_PACIENTE', paciente)
    },

    clearPaciente({ commit }) {
      commit('CLEAR_PACIENTE')
    },

    updatePaciente({ commit }, dadosAtualizados) {
      commit('UPDATE_PACIENTE', dadosAtualizados)
    }
  },

  getters: {
    paciente: state => state.paciente,
    hasPaciente: state => state.paciente !== null,
    pacienteId: state => state.paciente?.idPaciente || null,
    pacienteNome: state => state.paciente?.nomePaciente || '',
    pacienteProntuario: state => state.paciente?.idProntuario || null
  }
}

export default pacienteModule
